// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateCurrency_closeButton__1ZJyW"};